import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface StartPhoneVerificationResponse extends BackendResponse {}

export interface StartPhoneVerificationParameters extends NextApiParams {
  phone: string;
}

export const startPhoneVerification = withNextApi<
  StartPhoneVerificationResponse,
  StartPhoneVerificationParameters
>("/cvp/CvpStartPhoneVerification");
